import { Component } from "react";

export default class NoDictionarySelection extends Component {
  static CLASS_NAME = "no-dictionary-selection";

  render() {
    let className = NoDictionarySelection.CLASS_NAME;
    if (this.props.className) {
      className += " " + this.props.className;
    }
    return (
      <div className={className} style={this.props.style || {}}>
        {this.props.children}
      </div>
    );
  }
}
